"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParaSwap = void 0;
const axios_1 = __importDefault(require("axios"));
const qs = __importStar(require("qs"));
const _ = __importStar(require("lodash"));
const web3_1 = __importDefault(require("web3"));
const ERC20_ABI = require("./abi/erc20.json");
const AUGUSTUS_ABI = require("./abi/augustus-v4.json");
const token_1 = require("./lib/token");
const transaction_builder_1 = require("./lib/transaction-builder");
const constants_1 = require("./constants");
const API_URL = 'https://apiv4.paraswap.io/v2';
class ParaSwap {
    constructor(network = 1, apiURL = API_URL, web3Provider) {
        this.network = network;
        this.apiURL = apiURL;
        this.web3Provider = web3Provider;
        this.tokens = [];
        if (web3Provider && !web3Provider.eth) {
            this.web3Provider = new web3_1.default(web3Provider);
        }
    }
    setWeb3Provider(web3Provider) {
        if (!web3Provider.eth) {
            this.web3Provider = new web3_1.default(web3Provider);
        }
        else {
            this.web3Provider = web3Provider;
        }
        return this;
    }
    handleAPIError(e) {
        if (e.response) {
            const { data, status } = e.response;
            return { status, message: data.error };
        }
        return new Error(e.message);
    }
    getTokens() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const tokensURL = `${this.apiURL}/tokens/${this.network}`;
                const { data } = yield axios_1.default.get(tokensURL);
                this.tokens = data.tokens.map(t => new token_1.Token(t.address, t.decimals, t.symbol, t.tokenType, t.mainConnector, t.connectors, t.network, t.img));
                return this.tokens;
            }
            catch (e) {
                return this.handleAPIError(e);
            }
        });
    }
    getAdapters() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield axios_1.default.get(`${this.apiURL}/adapters/${this.network}`);
                this.adapters = data;
                return this.adapters;
            }
            catch (e) {
                return this.handleAPIError(e);
            }
        });
    }
    checkDexList(dexs) {
        if (dexs) {
            const targetDEXs = dexs.split(',');
            if (!targetDEXs.length) {
                throw new Error('Invalid DEX list');
            }
        }
    }
    getRateByRoute(route, amount, side, options, srcDecimals, destDecimals) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { excludeDEXS, includeDEXS, excludePricingMethods, excludeContractMethods, includeContractMethods, adapterVersion, excludePools, referrer, } = options || {};
                // TODO: all use typed enum for include/excludeDEXS
                // TODO: check the semver validity for the adapterVersion
                this.checkDexList(includeDEXS);
                this.checkDexList(excludeDEXS);
                const _excludePricingMethods = excludePricingMethods
                    ? excludePricingMethods.join(',')
                    : '';
                const _excludeContractMethods = excludeContractMethods
                    ? excludeContractMethods.join(',')
                    : '';
                const _includeContractMethods = includeContractMethods
                    ? includeContractMethods.join(',')
                    : '';
                if (route.length < 2) {
                    return { message: 'Invalid Route' };
                }
                const query = qs.stringify({
                    excludeDEXS,
                    includeDEXS,
                    excludePools,
                    version: adapterVersion,
                    excludePricingMethods: _excludePricingMethods,
                    excludeContractMethods: _excludeContractMethods,
                    includeContractMethods: _includeContractMethods,
                    fromDecimals: srcDecimals,
                    toDecimals: destDecimals,
                });
                const pricesURL = `${this.apiURL}/prices/?route=${route.join('-')}&amount=${amount}&${query}&side=${side}&network=${this.network}`;
                const { data } = yield axios_1.default.get(pricesURL, {
                    headers: {
                        'X-Partner': referrer || 'paraswap.io',
                    },
                });
                return data.priceRoute;
            }
            catch (e) {
                return this.handleAPIError(e);
            }
        });
    }
    getRate(srcToken, destToken, amount, side = constants_1.SwapSide.SELL, options = {}, srcDecimals, destDecimals) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { excludeDEXS, includeDEXS, excludePricingMethods, excludeContractMethods, includeContractMethods, adapterVersion, excludePools, referrer, } = options;
                // TODO: all use typed enum for include/excludeDEXS
                // TODO: check the semver validity for the adapterVersion
                this.checkDexList(includeDEXS);
                this.checkDexList(excludeDEXS);
                const _excludePricingMethods = excludePricingMethods
                    ? excludePricingMethods.join(',')
                    : undefined;
                const _excludeContractMethods = excludeContractMethods
                    ? excludeContractMethods.join(',')
                    : undefined;
                const _includeContractMethods = includeContractMethods
                    ? includeContractMethods.join(',')
                    : undefined;
                const query = qs.stringify({
                    excludeDEXS,
                    includeDEXS,
                    excludePools,
                    version: adapterVersion,
                    excludePricingMethods: _excludePricingMethods,
                    excludeContractMethods: _excludeContractMethods,
                    includeContractMethods: _includeContractMethods,
                    fromDecimals: srcDecimals,
                    toDecimals: destDecimals,
                });
                const pricesURL = `${this.apiURL}/prices/?from=${srcToken}&to=${destToken}&amount=${amount}${query ? '&' + query : ''}&side=${side}&network=${this.network}`;
                const { data } = yield axios_1.default.get(pricesURL, {
                    headers: {
                        'X-Partner': referrer || 'paraswap.io',
                    },
                });
                return data.priceRoute;
            }
            catch (e) {
                return this.handleAPIError(e);
            }
        });
    }
    buildTx(srcToken, destToken, srcAmount, destAmount, priceRoute, userAddress, referrer, receiver, options = {}, srcDecimals, destDecimals) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const query = _.isEmpty(options) ? '' : qs.stringify(options);
                const txURL = `${this.apiURL}/transactions/${this.network}/?${query}`;
                const txConfig = {
                    priceRoute,
                    srcToken,
                    destToken,
                    srcAmount,
                    destAmount,
                    userAddress,
                    referrer,
                    receiver: receiver || '',
                    srcDecimals,
                    destDecimals,
                };
                const config = {};
                if (referrer) {
                    config.headers = {
                        'X-Partner': referrer,
                    };
                }
                const { data } = yield axios_1.default.post(txURL, txConfig, config);
                return data;
            }
            catch (e) {
                return this.handleAPIError(e);
            }
        });
    }
    //Warning: ParaSwapPool is not supported when building locally
    buildTxLocally(srcToken, destToken, srcAmount, destAmount, priceRoute, userAddress, referrer, referrerIndex, gasPrice, receiver = transaction_builder_1.NULL_ADDRESS, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: fix me for multiple adapter version!
            if (!this.adapters) {
                yield this.getAdapters();
            }
            if (!this.tokens.length) {
                yield this.getTokens();
            }
            const augustusVersion = (priceRoute.adapterVersion &&
                constants_1.AdapterAugustusVersionMap[priceRoute.adapterVersion]) ||
                constants_1.latestAugustusVersion;
            // Todo: can be a member
            const transaction = new transaction_builder_1.TransactionBuilder(this.network, this.web3Provider, this.adapters, this.tokens, augustusVersion);
            return transaction.buildTransaction(srcToken, destToken, srcAmount, destAmount, priceRoute, userAddress, referrer, referrerIndex, gasPrice, receiver, !!options.ignoreChecks, augustusVersion, !!options.onlyParams, !!options.useReduxToken);
        });
    }
    getSpender(_provider) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.adapters) {
                const adaptersOrError = yield this.getAdapters();
                if (adaptersOrError.message) {
                    return adaptersOrError;
                }
                this.adapters = adaptersOrError;
            }
            const provider = this.web3Provider || _provider;
            const augustusAddress = this.adapters.augustus.exchange;
            const augustusContract = new provider.eth.Contract(AUGUSTUS_ABI, augustusAddress);
            return augustusContract.methods.getTokenTransferProxy().call();
        });
    }
    getAllowances(userAddress, tokenAddresses) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const balancesOrError = yield this.getBalances(userAddress);
                if (balancesOrError.message) {
                    return balancesOrError;
                }
                return balancesOrError
                    .filter(t => tokenAddresses.find(addr => addr.toLowerCase() === t.address.toLowerCase()))
                    .map(token => ({
                    tokenAddress: token.address,
                    allowance: token.allowance || '0',
                }));
            }
            catch (e) {
                return { message: e.message };
            }
        });
    }
    getAllowance(userAddress, tokenAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const allowanceOrError = yield this.getAllowances(userAddress, [
                    tokenAddress,
                ]);
                if (allowanceOrError.message) {
                    return allowanceOrError;
                }
                const allowances = allowanceOrError;
                if (!allowances.length) {
                    return { message: 'Not Found' };
                }
                return allowances[0];
            }
            catch (e) {
                return { message: e.message };
            }
        });
    }
    approveTokenBulk(amount, userAddress, tokenAddresses, _provider) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield Promise.all(tokenAddresses.map(tokenAddress => this.approveToken(amount, userAddress, tokenAddress, _provider)));
        });
    }
    approveToken(amount, userAddress, tokenAddress, _provider, sendOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                const spender = yield this.getSpender();
                const provider = _provider || this.web3Provider;
                const contract = new provider.eth.Contract(ERC20_ABI, tokenAddress);
                return contract.methods
                    .approve(spender, amount)
                    .send(Object.assign({ from: userAddress }, sendOptions), (err, txHash) => {
                    if (err)
                        return reject(err.message);
                    resolve(txHash);
                });
            }));
        });
    }
    getMarketNames() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield axios_1.default.get(`${this.apiURL}/adapters/list?namesOnly=true`);
                return data;
            }
            catch (e) {
                return this.handleAPIError(e);
            }
        });
    }
    getBalance(userAddress, token) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const tokensURL = `${this.apiURL}/users/tokens/${this.network}/${userAddress}/${token}`;
                    const { data } = yield axios_1.default.get(tokensURL);
                    resolve(data.token);
                }
                catch (e) {
                    reject({ error: e.message });
                }
            }));
        });
    }
    getBalances(userAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const tokensURL = `${this.apiURL}/users/tokens/${this.network}/${userAddress}`;
                    const { data } = yield axios_1.default.get(tokensURL);
                    const tokens = data.tokens.map(t => {
                        let token = new token_1.Token(t.address, t.decimals, t.symbol);
                        token.balance = t.balance;
                        token.allowance = t.allowance;
                        return token;
                    });
                    resolve(tokens);
                }
                catch (e) {
                    reject({ error: e.message });
                }
            }));
        });
    }
}
exports.ParaSwap = ParaSwap;
//# sourceMappingURL=paraswap.js.map